import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { Dashboard } from '../components/Dashboard';
import { useAuth } from '../context/AuthProvider';

export const AuthenticatedGuard = () => {
  const { isLoggedIn } = useAuth();
  const path = useLocation();

  if (!isLoggedIn) return <Navigate to={{ pathname: '/login' }} replace />;
  if (path.pathname === '/calculator') {
    return <Outlet />;
  }

  return (
    <Dashboard>
      <Outlet />
    </Dashboard>
  );
};
